module.exports = __webpack_public_path__ + "static/first-7c59e03a5c5cc17541bcc476a28fb851.png";